import { render } from "./SatinAlma_Sevkiyat.vue?vue&type=template&id=26a0473a"
import script from "./SatinAlma_Sevkiyat.vue?vue&type=script&lang=js"
export * from "./SatinAlma_Sevkiyat.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__